import * as React from 'react';
import { CloseButton } from 'ui';
import { SelectExpander } from './select-expander/select-expander';
import { DetailsExpander } from './details-expander/details-expander';
import { Footer } from './footer/footer';
import { HeaderWithRightToolbar } from './header/header-with-toolbar';
import { ReactNode, type JSX } from 'react';
import { Handlers, HotKeys, KeyMap } from 'ui/common/hotkeys';
import { keyCodeTypes } from "ui/common/key-code-types";

export interface DialogExpanderProps {
  id?: string;
  title?: string;
  onClose: () => void;
  onConfirm?: () => void;
  className?: string;
  hasFooter?: boolean;
  textDone?: string;
  disabled?: boolean;
  selectExpander?: boolean;
  extraFooterActions?: JSX.Element[];
  hasLongDescription?: boolean;
  leftElement?: JSX.Element;
  expandAll?: boolean;
  hideTitle?: boolean;
  children?: ReactNode;
}

export class DialogExpander extends React.Component<DialogExpanderProps, any> {
  public static defaultProps: Partial<DialogExpanderProps> = {
    className: '',
    hasFooter: true
  };

  private keyMap: KeyMap = {
    escapeKey: [keyCodeTypes.Esc]
  };

  private handlerHotkeys: Handlers = {
    escapeKey: () => this.props.onClose()
  };

  public render() {
    const {
      id,
      title,
      className,
      textDone,
      disabled,
      hasFooter,
      children,
      onConfirm,
      onClose,
      selectExpander,
      hasLongDescription,
      leftElement,
      expandAll,
      extraFooterActions
    } = this.props;

    const content = <>
      {!this.props.hideTitle
        && <HeaderWithRightToolbar
          title={title}
          leftElement={leftElement}
          className={className}
          hasLongDescription={hasLongDescription}>
          {!expandAll && <CloseButton onClick={onClose} />}
        </HeaderWithRightToolbar>}
      {children}
      {(hasFooter && !expandAll) &&
        <Footer onClose={onClose} onConfirm={onConfirm} textDone={textDone} disabled={disabled}>
          {extraFooterActions?.map(extraFooterAction =>
            <span key={extraFooterActions.indexOf(extraFooterAction)}>
              {extraFooterAction}
            </span>)}
        </Footer>}
    </>;

    return (
      <>
        <HotKeys keyMap={this.keyMap} handlers={this.handlerHotkeys}>
          {selectExpander ?
            <SelectExpander id={id} className={className}>
              {content}
            </SelectExpander>
            : <DetailsExpander id={id} expandAll={expandAll} className={className}>
              {content}
            </DetailsExpander>}
        </HotKeys>
      </>
    );
  }
}
